import React from 'react';
import appleStore from 'assets/images/landing/apple_store.svg';
import androidStore from 'assets/images/landing/android_store.svg';
import styles from './AppDownloadPromo.module.scss';

const AppDownloadPromo = () => (
  <div className={styles.container}>
    <p className={styles.heading}>Download the MyRAC app</p>
    <p className={styles.bodyText}>Download today and you can report if your vehicle has broken down, as well as planning a route, managing your membership, and setting vehicle reminders.</p>
    <div className={styles.buttonContainer}>
      <a href="https://apps.apple.com/gb/app/myrac/id350330435" rel="noopener noreferrer"><img className={styles.image} src={appleStore} alt="apple store" /></a>
      <a href="https://play.google.com/store/apps/details?id=uk.co.rac.roadside" rel="noopener noreferrer"><img className={styles.image} src={androidStore} alt="android store" /></a>
    </div>
  </div>
)

export default AppDownloadPromo;
